import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const OrgCloseStageFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const closeStages = useSortedCloseStages();

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            closeStages.map((stage) => ({
                value: stage.id,
                label: stage.name,
                searchableLabel: stage.name,
            })),
        [closeStages],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={filters.closeStageIds ?? []}
                onChange={(val) => {
                    const stageIds = val.map(String);
                    onChange({
                        closeStageIds: stageIds.length ? stageIds : undefined,
                    });
                }}
                name="orgCloseStage"
                onBlur={noop}
            />
        </div>
    );
};
